// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2RxdS","info":"UpdateTermsInfo_info__3Cxkt"};